import React, { Component } from "react";
import swal from "sweetalert";
import { toast } from "react-toastify";
import Pagination from "react-js-pagination";
import AddSharpIcon from "@material-ui/icons/AddSharp";
import { PiCloudArrowDownLight } from "react-icons/pi";
import SearchSharpIcon from "@material-ui/icons/SearchSharp";
import {
	FormControl,
	Button,
	InputGroup,
	Dropdown,
	Table,
	Tabs,
	Tab,
	Alert,
	OverlayTrigger,
	Tooltip
} from "react-bootstrap";
import axiosRequest from "axios";
import axios from "../../../axios";
import apiError from "../../../error";
import Loader from "../../../component/loader/loader";
import ADPassword from "../../../component/department/adPassword";
import Department from "../../../component/department/department";
import AzureModal from "../../../component/rightside-modal/azure-modal";
import GSuiteModal from "../../../component/rightside-modal/gsuite-modal";
import ADGroups from "../../../component/rightside-modal/right-side-group-ad";
import CustomGroupModal from "../../../component/Customgroup-right-modal/customgroup-modal";
import SearchUserModal from "../../../component/Customgroup-right-modal/searchuser-modal";
import { debounce } from '../../../function'

import "./department.css";
import { getCookie } from "../../../function";
import swalAlert from "../../../swalFunction";
import deleteGroupSwal from "../../../deleteGroupSwalFunction";
import LoadingDots from "../../../component/dots-loader/dots-loader";

var cancelRequest = undefined, CancelToken = axiosRequest.CancelToken;

export default class DepartmentList extends Component {
	constructor(props) {
		super(props);
		this.isTAconnected = getCookie('isTAconnected');
		this.isTASyncing = getCookie('isTASyncing');
		this.state = {
			count: 0,
			limit: 10,
			search: '',
			groups: [],
			activePage: 1,
			loading: true,
			syncLoading: false,
			showHierarchy: false,
			show: false,
			searchshowmodal: false,

			password: '',
			adModal: false,
			adLoading: false,
			showAdPassword: false,

			adGroups: [],
			groupModal: false,

			gsuiteModal: false,
			azureModal: false,
			permissibleActionsIAM: {},
			activeTab: "Directory",

			selectedTargets: [],
			customGroupName: "",
			selectedGroupId: "",
			remainingUsersLimit: null,
			licenseExpiredAt: "",
			selectedGroupType: "custom",

			isFromTAsyncing: false,
			fromTAsyncCompleted: false,
			toBeSyncedFromTA: false,
			showLimitInLabel: false
		}
	}
	handleSelect = (selectedTab) => {
		// if (selectedTab === "Directory") this.fetchAdminGroups(1, 10, "");
		// else this.fetchCustomGroups(1, 10, "");
		if (selectedTab === "Directory") this.fetchAllGroups("admin");
		else this.fetchAllGroups('custom');
		this.setState({ activeTab: selectedTab, activePage: 1, search: "", limit: 10 });
	};

	componentDidMount = () => {
		this.load();
		this.loadADPassword();
		this.loadPermissibleActions();
		if (this.isTAconnected) this.invokeGetFromTASyncStatus();
	}
	componentWillUnmount = () => {
		clearInterval(this.intervalId);
		this.intervalId = null;
	}
	setCustomGroupName = (groupName) => {
		this.setState({ customGroupName: groupName })
	}

	setSelectedTargets = (selectedTargetsTotal) => {
		this.setState({ selectedTargets: selectedTargetsTotal })
	}

	nextPath = path => this.props.history.push(path);

	load = debounce(async (fromTASyncStartTime) => {
		if (this.isTAconnected) {
			if (this.state.activeTab === "Directory") {
				// this.fetchAdminGroups(this.state.activePage, this.state.limit, this.state.search);
				this.fetchAllGroups("admin", fromTASyncStartTime);
			} else {
				// this.fetchCustomGroups(this.state.activePage, this.state.limit, this.state.search);
				this.fetchAllGroups("custom");
			}
		} else {
			this.fetchAllGroups();
		}
		this.fetchLicenseDetails();

	}, 500)

	fetchCustomGroups = (page, limit, search) => {
		this.setState({ loading: true });
		if (cancelRequest) cancelRequest();
		axios
			.get("/api/groups", {
				params: {
					page,
					limit,
					search,
					type: 'custom'
				},
				cancelToken: new CancelToken(function executor(c) {
					cancelRequest = c;
				}),
			})
			.then(async (res) => {
				await this.setState({
					loading: false,
					count: res.data.count,
					groups: res.data.groups,
				});
			})
			.catch((error) => {
				if (!axiosRequest.isCancel(error)) {
					this.setState({ groups: [], count: 0, loading: false });
					apiError(error);
				}
			});
	}

	fetchAdminGroups = (page, limit, search) => {
		this.setState({ loading: true });
		if (cancelRequest) cancelRequest();
		axios.get('/api/adminCentral/list-groups', {
			params: {
				page,
				limit,
				search
			},
			cancelToken: new CancelToken(function executor(c) { cancelRequest = c })
		})
			.then(async (res) => {
				this.setState({
					loading: false,
					count: res.data.response.groupCount,
					groups: res.data.response.groups,
				})
			})
			.catch(error => {
				if (!axiosRequest.isCancel(error)) {
					this.setState({ groupTargets: [], count: 0, loading: false });
					apiError(error);
				}
			});
	}

	fetchAllGroups = (type = "", fromTASyncStartTime = null) => {
		this.setState({ loading: !fromTASyncStartTime });
		if (cancelRequest) cancelRequest();
		axios.get('/api/groups', {
			params: {
				page: this.state.activePage,
				limit: this.state.limit,
				search: this.state.search,
				fromTASyncStartTime,
				type
			},
			cancelToken: new CancelToken(function executor(c) { cancelRequest = c })
		})
			.then(async (res) => {
				await this.setState({
					loading: false,
					count: res.data.count,
					groups: res.data.groups,
				})
			})
			.catch(error => {
				if (!axiosRequest.isCancel(error)) {
					this.setState({ groups: [], count: 0, loading: false })
					apiError(error);
				}
			})
	}

	handleDeleteGroup = (groupId) => {
		let swalFun = this.isTAconnected ? swal : deleteGroupSwal;
		swalFun({
			title: "Are You Sure You Want To Delete This Group",
			icon: "warning",
			buttons: ['No', 'Yes'],
			dangerMode: true,
		})
			.then(async deleteType => {
				if (deleteType) {
					this.setState({ loading: true })
					axios.delete(`/api/groups/${groupId}?deleteType=${deleteType}`)
						.then(r => {
							this.setState({ loading: false })
							toast.success("Group Deleted Successfully");
							this.load();
						})
						.catch(error => {
							this.setState({ loading: false })
							apiError(error);
						})
				}
			});
	}
	handleGroupCSV = () => {
		// Create a timeout to show the toast if API takes more than 2 seconds
		let toastTimeout = setTimeout(() => {
			toast.info("Group CSV is being prepared, please wait...");
		}, 300);

		axios
			.get('/api/groups/csv', {})
			.then(async (res) => {
				// Clear the toast timeout since the API responded
				clearTimeout(toastTimeout);

				// Process the file download
				const url = window.URL.createObjectURL(new Blob([res.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', `GroupsList.csv`);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
			.catch((error) => {
				// Clear the toast timeout if there's an error
				clearTimeout(toastTimeout);
				apiError(error);
			});
	};

	loadADPassword = () => {
		axios
			.get("/api/meta/ad", {})
			.then((res) => {
				if (res.data && res.data.data && res.data.data.value) {
					var value = JSON.parse(res.data.data.value);
					this.setState({ showAdPassword: !value.savePassword });
				}
			})
			.catch((err) => {
				apiError(err);
			});
	};

	setTreeJson = (obj, t, group, dataObj) => {
		if (group && group.length > 0) {
			group.forEach((g) => {
				var temp = {
					text: `<a href="/department/groups/${g.id}">${g.name}  ( ${g.targets} Targets )</a>`,
					id: g.id,
				};
				if (dataObj && dataObj[g.id]) {
					temp["state"] = { opened: true };
					temp["children"] = this.setTreeJson([], "c", dataObj[g.id], dataObj);
				}
				obj.push(temp);
			});
		}
		return obj;
	};

	syncGroups = async () => {
		await this.setState({ syncLoading: true, loading: true });
		axios
			.get("/api/groups/sync", {})
			.then((r) => {
				var count = 1;
				toast.success("Group Sync Will Be Done Soon");
				var interval = setInterval(() => {
					this.load();
					if (count === 5) {
						clearInterval(interval);
					}
					count = count + 1;
				}, 5000);
				this.setState({ syncLoading: false });
			})
			.catch((error) => {
				this.setState({ syncLoading: false, loading: false });
				if (error.response.data.errors[0] === "TLMS_CONNECTED_TO_THREATCOP_ADMIN") {
					swalAlert("TLMS connected to Threatcop Admin", "This function has been terminated. Users and groups must now be assigned through Threatcop Admin. Please connect TSAT with Threatcop Admin and assign users accordingly.", "error");
					return;
				}
				apiError(error);
			});
	};

	handleADSAVE = async () => {
		if (
			(this.state.password && this.state.password.length) ||
			!this.state.showAdPassword
		) {
			await this.setState({ adLoading: true });
			axios
				.post("/api/groups/check/AD", {
					password: this.state.password,
				})
				.then((res) => {
					this.loadAdGroups();
					toast.success(res.data.message);
					this.setState({ adLoading: false, adModal: false });
				})
				.catch((err) => {
					apiError(err);
					this.setState({ adLoading: false });
				});
		} else {
			toast.error("Please Enter Password");
		}
	};

	handleShowModal = () => {
		if (this.state.showAdPassword) {
			this.setState({ adModal: true });
		} else {
			this.handleADSAVE();
		}
	};

	loadAdGroups = async () => {
		await this.setState({ loading: true });
		axios
			.get("/api/groups/active/directory/groups", {
				password: this.state.password,
			})
			.then((res) => {
				this.setState({
					loading: false,
					groupModal: true,
					adGroups: res.data.groups,
				});
			})
			.catch((err) => {
				apiError(err);
				this.setState({ loading: false });
			});
	};

	handleGSuiteModal = () => {
		this.setState({ gsuiteModal: !this.state.gsuiteModal });
	};
	handleAzureModal = () => {
		this.setState({ azureModal: !this.state.azureModal });
	};

	responseGoogle = async (response) => {
		try {
			if (response && response.accessToken && response.accessToken.length > 0) {
				this.setState({ loading: true });

				let googleAdminSettingsObject = {
					accessToken: response.accessToken,
					email: response.profileObj.email,
				};
				let setting = await axios.get("/api/googlesync/getGoogleAdminSettings");
				if (setting.data.groupEnabled) {
					googleAdminSettingsObject["groupId"] = setting.data.groupId;
				}
				await axios.post("/api/groups/g-suite", googleAdminSettingsObject);
				this.load();
				this.handleGSuiteModal();
				this.setState({ gsuiteModal: false });
				toast.success("G-Suite User List Will Be Updated Soon");
			} else {
				throw Error("Invalid Response From GoogleAdmin");
			}
		} catch (err) {
			apiError(err);
			this.setState({ loading: false });
		}
	};

	responseAzure = (error, response) => {
		if (!error && response && response.accessToken && response.accessToken.length) {
			this.setState({ loading: true })
			axios.post('/api/groups/azure', {
				accessToken: response.accessToken,
				adminEmail: response.account.username ? response.account.username : null,
				groups: ((response.groups)?.length > 0) ? response.groups : [{ azureGroupId: null }]
			})
				.then(res => {
					this.load();
					this.handleAzureModal();
					this.setState({ azureModal: false });
					toast.success("Azure User List Will Be Updated Soon");
				})
				.catch(err => {
					//hacky fix
					//this code is  redundant
					let errString = err.response.data.errors[0];
					if (errString.includes('License Limit Exceeded')) {
						const regex = /file:(.+)/;
						const match = errString.match(regex);
						let fileName;
						if (match && match[1]) {
							fileName = match[1].trim();
							// Triggering a download
							const link = document.createElement('a');
							link.href = `${process.env.REACT_APP_API_URL}/staticpra/failedcsv/${fileName}`; // Assuming fileName is the full path to the file
							link.download = 'failed-users.csv';   // This will make it download using the original file name. You can provide a name if you want to rename the downloaded file.
							document.body.appendChild(link);
							link.click();
							document.body.removeChild(link);
						}
						err.response.data.errors[0] = 'License Limit Exceeded';
					}
					apiError(err);
					this.setState({ loading: false })
				})
		} else {
			console.log(error); // Log the error to diagnose issues
		}
	}
	setShow = (showValue) => {
		this.setState({ show: showValue })
	}
	setSelectedGroupId = (groupId) => {
		this.setState({ selectedGroupId: groupId })
	}
	setSelectedGroupType = (type) => {
		this.setState({ selectedGroupType: type })
	}
	fetchLicenseDetails = async () => {
		try {
			let licenseDetails = await axios.get('/api/overview/licence');
			this.setState({ remainingUsersLimit: licenseDetails.data.userlimit - licenseDetails.data.targetCount, licenseExpiredAt: new Date(licenseDetails.data.expiredAt) });
		} catch (error) {
			apiError(error);
		}
	}

	loadPermissibleActions = async () => {
		try {
			let permissibleActions = await axios.post('/api/iam-user/permissions', {
				actions: ['user-and-department-write', 'user-and-department-delete']
			});
			this.setState({ permissibleActionsIAM: permissibleActions.data.permissibleObj });
		} catch (error) {
			console.log("Error occured while fetching permissibleActionsIAM: ", error);
		}
	}
	syncTAconnected = async () => {
		try {
			this.setState({ loading: true });
			await axios.post('/api/adminCentral/sync-from-ta-groups');
			this.setState({ loading: false });
			this.invokeGetFromTASyncStatus();
		} catch (error) {
			this.setState({ loading: false });
			apiError(error);
		}
	}
	getFromTASyncStatus = async () => {
		try {
			const response = await axios.get('/api/adminCentral/get-ta-groups-status');
			const { toBeSyncedFromTA, isFromTAsyncing, fromTASyncStartTime } = response.data;
			this.setState({ isFromTAsyncing, toBeSyncedFromTA })
			this.load(fromTASyncStartTime);
			if (!isFromTAsyncing) {
				clearInterval(this.intervalId);
				this.intervalId = null;
			}
		} catch (error) {
			clearInterval(this.intervalId);
			this.intervalId = null;
			console.log("error occure while fetching fromTASync status: ", error);
		}
	}
	invokeGetFromTASyncStatus = async () => {
		this.getFromTASyncStatus();
		this.intervalId = setInterval(async () => {
			await this.getFromTASyncStatus();
		}, 5000);
	}
	sendGroupToLMS = async (groupId) => {
		try {
			this.setState({ loading: true });
			let response = await axios.post(`/api/groups/send-group-to-lms/${groupId}`, {});
			this.setState({ loading: false });
			if (response.data.isAlreadySyncing) toast.info(response.data.message);
			else toast.success(response.data.message);
		} catch (error) {
			this.setState({ loading: false });
			apiError(error);
		}
	}

	render() {
		return (
			<>
				<div className="content-wrap">
					<div className="breadcrumbbar">
						<div className="flexRow row">
							<div className={`col-md-4`} style={{ textAlign: 'left', paddingLeft: 0 }}>
								<div className="page-head d-flex align-items-center justify-content-between">
									<h4 className="page-title" >Groups</h4>
								</div>
							</div>

							<div className={"col-md-8 flexFilterButtons"}>
								<div className="btn-container float-right d-flex align-items-center">

									{!this.isTAconnected &&
										<Dropdown className="dropdownIcon">
											<Dropdown.Toggle id="dropdown-basic" variant="secondary" className="dropdown-toggle mr-2" disabled={!this.state.permissibleActionsIAM['user-and-department-write'] || this.isTASyncing}>
												<PiCloudArrowDownLight className="ti-cloud-down tiIcon" />Import Groups
											</Dropdown.Toggle>
											<Dropdown.Menu>
												<Dropdown.Item onClick={this.handleGSuiteModal}>Import from G-Suite</Dropdown.Item>
												<Dropdown.Item onClick={this.handleAzureModal}>Import With Azure</Dropdown.Item>
												<Dropdown.Item onClick={this.handleShowModal}>Import from AD</Dropdown.Item>
												<Dropdown.Item onClick={this.syncGroups}>Sync from TLMS</Dropdown.Item>
											</Dropdown.Menu>
										</Dropdown>
									}
									<Button
										style={{ marginRight: '6px' }}
										variant="secondary"
										onClick={this.handleGroupCSV}>
										<span className="btn-text">Export CSV</span>
									</Button>
									<OverlayTrigger
										placement="top"
										overlay={
											this.isTASyncing ? (
												<Tooltip id="top"> <span>Threatcop Admin Sync is already in progress</span>
												</Tooltip>
											) : (
												!this.state.permissibleActionsIAM['user-and-department-write']
													? (<Tooltip id="top">You don't have permission to access</Tooltip>)
													: (<Tooltip id="top" className="d-none"></Tooltip>)
											)
										}
									>
										<Button
											variant="primary"
											className={`${this.isTASyncing && "disabledCls2"}`}
											onClick={() => { if (!this.isTASyncing && this.state.permissibleActionsIAM['user-and-department-write']) return this.setState({ show: true }) }}
										>
											<AddSharpIcon className="btn-icon"></AddSharpIcon>
											<span className="btn-text">{this.isTAconnected ? "Create Custom Group" : "Create Group"}</span>
										</Button>
									</OverlayTrigger>
								</div>
							</div>
						</div>
					</div>

					{this.isTAconnected ? (
						<>
							<div className="contentbar">
								<div className="filter-without-border">
									<div className="align-items-center row" id="tab-wrapper">
										<div className="col-md-3 hide-tab-content">
											<Tabs
												activeKey={this.state.activeTab}
												onSelect={this.handleSelect}
												id="controlled-tab-example"
												className="groupTab p-0 "
											>
												<Tab eventKey="Directory" title="Directory" />
												<Tab eventKey="Custom" title="Custom" />
											</Tabs>
										</div>

										<div className="col-sm-9">
											<div className="rightFilters">
												<div className="positionSearchIcon">
													<InputGroup>
														<FormControl
															type="text"
															placeholder="Search"
															value={this.state.search}
															className="inputSearch mr-sm-2 form-control"
															onChange={(e) =>
																this.setState(
																	{ search: e.target.value, activePage: 1 },
																	() => {
																		this.load();
																	}
																)
															}
														/>
														<SearchSharpIcon className="search-icon"></SearchSharpIcon>
													</InputGroup>
												</div>
												<Dropdown className="d-inline-block">
													<Dropdown.Toggle variant="secondary" id="limit-dropdown" className="dropdown-color-white mr-2">
														Show{this.state.showLimitInLabel ? ` (${this.state.limit})` : ''}
													</Dropdown.Toggle>
													<Dropdown.Menu>
														{[10, 25, 50, 100].map((limit) => (
															<Dropdown.Item
																key={`limit-${limit}`}
																onClick={() => this.setState({ limit: limit, activePage: 1, showLimitInLabel: true }, () => this.load())}
																active={this.state.limit === limit}
															>
																{limit}
															</Dropdown.Item>
														))}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</div>
									</div>
								</div>
								{
									this.isTAconnected && this.state.toBeSyncedFromTA &&
									<div className="alignItemsCenter contentbar" style={{ paddingTop: 0, paddingBottom: 0 }}>
										<Alert variant="danger" style={{
											padding: '6px',
											alignItems: 'center',
											marginTop: '12px',
											marginBottom: 0
										}}>
											<h6 style={{
												fontSize: '14px',
												padding: '2px 0',
												margin: '2px',
											}}>Something went wrong while syncing users and groups. To resolve this, please click Retry to reinitiate the process. <span style={{ textDecoration: 'underline', color: 'blue', cursor: 'pointer', marginLeft: '2px' }} onClick={this.syncTAconnected}>Retry</span></h6>
										</Alert>
									</div>
								}
								{this.state.isFromTAsyncing &&
									<div className="alignItemsCenter contentBar" style={{ padding: "0 15px" }}>
										<Alert variant="success" style={{
											padding: '6px',
											alignItems: 'center',
											marginTop: '12px',
											marginBottom: 0
										}}>
											<h6 style={{
												fontSize: '14px',
												padding: '2px 0',
												margin: '2px',
											}}><LoadingDots width="100%">Groups from Threatcop Admin are currently being synced</LoadingDots></h6>
										</Alert>
									</div>
								}
								<div className="tableContainerWrapInner">
									<Table responsive>
										<thead className="bg-light">
											<tr>
												<th>Group Name</th>
												<th>Users</th>
												<th>Created On</th>
												<th>Last Updated</th>
												{/* <th>Members</th>
												<th>Status</th> */}
												<th>Action</th>
											</tr>
										</thead>
										{this.state["groups"] && this.state["groups"].length ? (
											this.state["groups"].map((group, index) => {
												return (
													<Department
														key={index}
														group={group}
														index={index}
														nextPath={this.nextPath}
														handleDeleteGroup={this.handleDeleteGroup}
														setSelectedGroupId={this.setSelectedGroupId}
														setShow={this.setShow}
														setCustomGroupName={this.setCustomGroupName}
														groupType={group.type}
														setSelectedGroupType={this.setSelectedGroupType}
														permissibleActionsIAM={this.state.permissibleActionsIAM}
														sendGroupToLMS={this.sendGroupToLMS}
													></Department>
												);
											})
										) : (
											<h6 className="noGroupfound">No groups found</h6>
										)}
									</Table>
									<div className="pagination-Wrap">
										<div className="row">
											<div className="col-md-6">
												{!this.state["loading"] ? (
													<Pagination
														itemClass="page-item"
														linkClass="page-link"
														activePage={this.state.activePage}
														itemsCountPerPage={this.state.limit}
														totalItemsCount={this.state.count}
														onChange={(pageNumber) =>
															this.setState({ activePage: pageNumber }, () =>
																this.load()
															)
														}
													/>
												) : null}
											</div>
											<div className="col-md-6 text-right d-flex align-items-center footer-pg">
												<div className="w-100 pgCount">
													<p>
														{this.state.count === 0
															? 0
															: this.state.activePage * this.state.limit + 1 - this.state.limit}
														-
														{this.state.activePage * this.state.limit > this.state.count
															? this.state.count
															: this.state.activePage * this.state.limit}{" "}
														of {this.state.count} records
													</p>
													{/* <p>Total No Of Groups: {this.state.count} </p>{" "} */}
												</div>
											</div>
										</div>
									</div>
								</div>
								<ADPassword
									adModal={this.state.adModal}
									password={this.state.password}
									adLoading={this.state.adLoading}
									handleADSAVE={this.handleADSAVE}
									handleAdModal={(e) => this.setState({ adModal: false })}
									handlePassword={(e) =>
										this.setState({ password: e.target.value })
									}
								></ADPassword>
								<ADGroups
									show={this.state.groupModal}
									adGroups={this.state.adGroups}
									handleAdGroup={(e) => this.setState({ groupModal: false })}
									remainingUsersLimit={this.state.remainingUsersLimit}
								></ADGroups>
								<GSuiteModal
									remainingUsersLimit={this.state.remainingUsersLimit}
									show={this.state.gsuiteModal}
									showHandle={this.handleGSuiteModal}
									responseGoogle={this.responseGoogle}
								></GSuiteModal>
								<AzureModal
									remainingUsersLimit={this.state.remainingUsersLimit}
									show={this.state.azureModal}
									showHandle={this.handleAzureModal}
									responseAzure={this.responseAzure}
								></AzureModal>
								{this.state.loading ? <Loader /> : null}
							</div>
						</>
					) : (
						<>

							<div className="contentbar">
								<div className="filter-without-border">
									<div className="align-items-center row">
										<div className="col-md-3">
											<div className="positionSearchIcon">
												<InputGroup>
													<FormControl type="text" placeholder="Search" value={this.state.search} className="inputSearch mr-sm-2 form-control" onChange={e => this.setState({ search: e.target.value, activePage: 1 }, () => { this.load() })} /><SearchSharpIcon className="search-icon"></SearchSharpIcon>
												</InputGroup>
											</div>
										</div>

										<div className="col-sm-9">
											<div className="rightFilters">
											<Dropdown className="d-inline-block">
													<Dropdown.Toggle variant="secondary" id="limit-dropdown" className="dropdown-color-white mr-2">
														Show{this.state.showLimitInLabel ? ` (${this.state.limit})` : ''}
													</Dropdown.Toggle>
													<Dropdown.Menu>
														{[10, 25, 50, 100].map((limit) => (
															<Dropdown.Item
																key={`limit-${limit}`}
																onClick={() => this.setState({ limit: limit, activePage: 1, showLimitInLabel: true }, () => this.load())}
																active={this.state.limit === limit}
															>
																{limit}
															</Dropdown.Item>
														))}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</div>
									</div>
								</div>

								{(this.state.licenseExpiredAt && this.state.licenseExpiredAt <= new Date()) ? (
									<div
										style={{
											lineHeight: '1.2',
											borderRadius: 'none'
										}}
										className="licensAlert mb-3"
									>
										<Alert
											variant="danger"
											style={{
												padding: '6px 15px',
												margin: '0'
											}}
										>
											<h6>Your license has been expired...</h6>
										</Alert>
									</div>

								) : (
									(this.state.remainingUsersLimit && this.state.remainingUsersLimit > 0 ?
										(
											<div className="noteSection mt-0 mb-3">
												<p><b>Please Note:</b> You can onboard {this.state.remainingUsersLimit} more unique users before reaching your limit. </p>
											</div>

										) : (
											((this.state.remainingUsersLimit !== undefined && this.state.remainingUsersLimit !== null && this.state.remainingUsersLimit !== "" && this.state.remainingUsersLimit <= 0) ?
												<div

													className="licensAlert mb-3"
												>
													<Alert
														variant="danger"

													>
														<h6 >Your user license limit has been reached. To add more users, please upgrade your license or remove existing users</h6>
													</Alert>
												</div> : ("")
											)
										)
									)

								)}

								<div className="tableContainerWrapInner">
									<Table responsive>
										<thead className="bg-light">
											<tr>
												<th>Group Name</th>
												<th>Members</th>
												<th>Created On</th>
												<th>Last Updated</th>
												<th>Action</th>
											</tr>
										</thead>

										{this.state['groups'] && this.state['groups'].length ?
											this.state['groups'].map((group, index) => {
												return <Department
													key={index}
													group={group}
													index={index}
													nextPath={this.nextPath}
													handleDeleteGroup={this.handleDeleteGroup}
													permissibleActionsIAM={this.state.permissibleActionsIAM}
													setShow={this.setShow}
													setSelectedGroupId={this.setSelectedGroupId}
													setCustomGroupName={this.setCustomGroupName}
													groupType={group.type}
													setSelectedGroupType={this.setSelectedGroupType}
													sendGroupToLMS={this.sendGroupToLMS}
												></Department>
											}) : <h6 className="noGroupfound">No groups found</h6>
										}
									</Table>
									<div className="pagination-Wrap">
										<div className="row">
											<div className="col-md-6">
												{!this.state['loading'] ?
													<Pagination
														itemClass="page-item"
														linkClass="page-link"
														activePage={this.state.activePage}
														itemsCountPerPage={this.state.limit}
														totalItemsCount={this.state.count}
														onChange={(pageNumber) => this.setState({ activePage: pageNumber }, () => this.load())}
													/> : null
												}
											</div>
											<div className="col-md-6 text-right d-flex align-items-center footer-pg">
												<div className="w-100 pgCount">
													<p>{this.state.count === 0 ? 0 : this.state.activePage * this.state.limit + 1 - this.state.limit}-
														{this.state.activePage * this.state.limit > this.state.count ? this.state.count : this.state.activePage * this.state.limit} of {this.state.count} records</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								<ADPassword
									adModal={this.state.adModal}
									password={this.state.password}
									adLoading={this.state.adLoading}
									handleADSAVE={this.handleADSAVE}
									handleAdModal={e => this.setState({ adModal: false })}
									handlePassword={e => this.setState({ password: e.target.value })}
								></ADPassword>
								<ADGroups
									show={this.state.groupModal}
									adGroups={this.state.adGroups}
									handleAdGroup={e => this.setState({ groupModal: false })}
								></ADGroups>
								<GSuiteModal
									remainingUsersLimit={this.state.remainingUsersLimit}
									show={this.state.gsuiteModal}
									showHandle={this.handleGSuiteModal}
									responseGoogle={this.responseGoogle}
								></GSuiteModal>
								<AzureModal
									remainingUsersLimit={this.state.remainingUsersLimit}
									show={this.state.azureModal}
									showHandle={this.handleAzureModal}
									responseAzure={this.responseAzure}
								></AzureModal>
								{this.state.loading ? <Loader /> : null}
							</div>
						</>
					)}
				</div>
				<CustomGroupModal
					selectedGroupId={this.state.selectedGroupId}
					setSelectedGroupId={this.setSelectedGroupId}
					show={this.state.show}
					selectedTargets={this.state.selectedTargets}
					setSelectedTargets={this.setSelectedTargets}
					customGroupName={this.state.customGroupName}
					setCustomGroupName={this.setCustomGroupName}
					loadGroups={this.load}
					searchshowmodal={this.state.searchshowmodal}
					searchOnClickHandler={() =>
						this.setState(() => (this.state.searchshowmodal = true))
					}
					handleModal={() => {
						this.setState({
							show: !this.state.show,
						});
					}}
					groupType={this.state.selectedGroupType}
					setSelectedGroupType={this.setSelectedGroupType}
					permissibleActionsIAM={this.state.permissibleActionsIAM}
					handleTabSelect={this.handleSelect}
				></CustomGroupModal>

				<SearchUserModal
					show={this.state.searchshowmodal}
					selectedTargets={this.state.selectedTargets}
					setSelectedTargets={this.setSelectedTargets}
					selectedGroupId={this.state.selectedGroupId}
					onCloseHandler={() =>
						this.setState(() => (this.state.searchshowmodal = false))
					}
					handleModal={() => {
						this.setState({
							show: !this.state.searchshowmodal,
						});
					}}
				></SearchUserModal>
			</>
		);
	}
}